<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import {
  ENGAGEMENT_ICONS,
  EngagementActionMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import ActiveActionIcon from "%/dynamic-component-editor/options/active-action-icon";
import ActiveIconColor from "%/dynamic-component-editor/options/active-icon-color";
import { useStoryCommentsStore } from "%/dynamic-component-editor/stores/story-comments-store";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import {
  isLiked,
  engagementFieldsFromStoryPageRecord,
  tapStoryLike,
} from "%/dynamic-component-editor/standard-components/base-story-card/story-engagement-actions";

export default {
  name: "LikeAction",
  actionLabel: "Like",
  elementPanelSettings: {
    displayIcon: "heart",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [StoryPageElementMixin, EngagementActionMixin],
  options: [
    new ActiveActionIcon({ "default": ENGAGEMENT_ICONS.liked }),
    new ActiveIconColor(),
  ],
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.like }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canLikePosts",
    ]),
    suppressPaddingAdjustment() {
      return true;
    },
    isEngagementActive() {
      return isLiked(this.entity?.likeStatus);
    },
    engagementActiveIconColor() {
      return this.getOptionValue(ActiveIconColor);
    },
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.numLikes ?? 0 : "";
    },
    shouldShowAction() {
      return this.editMode || this.canLikePosts;
    },
  },
  watch: {
    engagementActiveIconColor: {
      immediate: true,
      handler(color) {
        useStoryCommentsStore().setLikedHeartColor(this.storyEntityId, color);
      },
    },
  },
  methods: {
    handleClick() {
      if (this.editMode || this.isPreviewMode || !this.canLikePosts) {
        return;
      }
      tapStoryLike(this.storyEntityId, engagementFieldsFromStoryPageRecord(this.entity));
    },
  },
};
</script>
